import { gql } from 'graphql-request';

export const ThemeFragment = gql`
  fragment Theme on ExperienceTheme {
    id
    name
    description
    createdAt
    updatedAt
    bannerImageId
    bannerImageType
    heroImageId
    heroImageType
    logoImageId
    logoImageType
    colorType
    hue
    saturation
    lightness
    customHue
    customSaturation
    customLightness
    bold
    sparkle
  }
`;
